module.exports = __webpack_public_path__ + "static/media/icon-sanzhisongshu@2x.4b4a19d5.png";